import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Axios from 'axios';

import { Loading } from './Loading';
import { UserContext, SnackbarContext } from './userContext';
import { AccountHeader, EmptyBlock, Icon } from './myacc/primitives';

function Line({ label, children }) {
  return (
    <div className="text-[12.5px] leading-[1.5]">
      <span className="text-fg-tertiary">{label}: </span>
      <span className="font-semibold text-fg-primary break-words">{children}</span>
    </div>
  );
}

export const MyAccContactedCustomersEngWf = () => {
  const history = useNavigate();
  const { user, setUser } = useContext(UserContext);
  const { setSnack } = useContext(SnackbarContext);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Axios.post('/new_apis/getcontactedcustomers-eng-wf',
      { uid: user.user_id, cat: user.category_ids, role: user.user_role },
      { headers: { tkn: user.token } },
    ).then((res) => {
      const s = res.data.status;
      if (s === 1) {
        setData(res.data.custhist || []);
        setLoading(false);
      } else if (s === 3) {
        history('/');
        setSnack({ message: res.data.msg, type: 'warning', open: true, direction: 'left' });
      } else if (s === 4) {
        setUser(null);
        history('/');
        localStorage.removeItem('estkn');
        setSnack({ message: res.data.msg, type: 'warning', open: true, direction: 'left' });
      }
    });
  }, []); // eslint-disable-line

  if (loading) return <Loading />;

  return (
    <>
      <AccountHeader
        kicker="Contacts"
        title="Contacted users"
        subtitle="People who reached out to your engineer or workforce profile."
      />

      {data.length === 0 ? (
        <EmptyBlock
          icon={<Icon.Users className="h-7 w-7" />}
          title="No contact requests yet"
          subtitle="When users contact your profile, they'll appear here."
        />
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {data.map((item, i) => {
            const initial = (item.first_name || '?').trim().charAt(0).toUpperCase();
            return (
              <article
                key={i}
                className="
                  relative flex flex-col gap-2 overflow-hidden
                  rounded-2xl border border-border-subtle bg-surface-paper p-4
                  transition-[border-color,transform] duration-200 ease-out-soft
                  hover:border-amber/30 hover:-translate-y-0.5
                "
              >
                <div className="flex items-center gap-3">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-amber/40 bg-gradient-to-br from-amber/30 to-amber/8 text-amber font-bold text-[15px]">
                    {initial}
                  </div>
                  <div className="min-w-0">
                    <h3 className="truncate text-[14px] font-bold text-fg-primary">{item.first_name}</h3>
                    <div className="text-[10.5px] uppercase tracking-[0.14em] text-fg-tertiary">Contacted you</div>
                  </div>
                </div>
                <div className="border-t border-border-subtle pt-2.5 space-y-0.5">
                  <Line label="Mobile">{item.phone}</Line>
                  {item.email && <Line label="Email">{item.email}</Line>}
                  <Line label="Contacted">{item.date}</Line>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </>
  );
};
